import { render, staticRenderFns } from "./MilestoneTrashView.vue?vue&type=template&id=46fe0f9e&"
import script from "./MilestoneTrashView.vue?vue&type=script&lang=js&"
export * from "./MilestoneTrashView.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneTrashView.vue?vue&type=style&index=0&id=46fe0f9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports